import React from 'react';
import { TriggerProps, useFaContent, useInitiateMatchTriggers } from 'src/feature-app';
import { GTI50Controller, ProspectsCalculadoraEmbedded, ProspectsMatchEmbedded } from 'src/forms';
import { ProspectsActionTrigger } from './ProspectsActionTrigger';

export function ProspectsEmbeddedTrigger({ setSelectedJourney }: TriggerProps): JSX.Element {
	const { featureApp } = useFaContent();
	if (featureApp === 'es-match') {
		useInitiateMatchTriggers(setSelectedJourney, <ProspectsMatchEmbedded />);
	} else if (featureApp === 'es-calculadora') {
		return <ProspectsCalculadoraEmbedded setSelectedJourney={setSelectedJourney} />;
	} else if (featureApp === 'es-gti-50') {
		return <GTI50Controller setSelectedJourney={setSelectedJourney} />;
	} else if (featureApp === 'action') {
		return <ProspectsActionTrigger setSelectedJourney={setSelectedJourney} />;
	}

	return null;
}
